<div class="flex-it flex-col" class="context-selector">
  @if (action?.editable) {
    <div>
      <button
        class=""
        mat-icon-button
        color="primary"
        (click)="setActions('confirm', false)"
      >
        <ng-icon
          name="HeroCheckSolid"
          class="confirm icon-fw"
          matTooltip="Confirm"
        ></ng-icon>
      </button>
      <button
        #cancelButton
        mat-icon-button
        color="warn"
        (click)="setActions('edit', false)"
      >
        <ng-icon
          name="HeroX"
          class="cancel icon-fw"
          matTooltip="Cancel"
        ></ng-icon>
      </button>
    </div>
  }
  @if (!action?.editable) {
    <div [matMenuTriggerFor]="menu" class="mouse-pointer">
      <ng-icon
        name="HeroDotsHorizontal"
        class="icon-three-dots"
        matTooltip="More Actions"
      ></ng-icon>
    </div>
  }

  <mat-menu #menu="matMenu" class="data-source-menu">
    <div class="flex-it flex-row">
      <div Style="width:100%;" class="flex-it flex-col">
        @for (item of itemsMenu; track item) {
          <button
            mat-menu-item
            (click)="setActions(item?.name, item?.edit)"
            class="{{ item?.setclass }}"
          >
            {{ item?.name }}
          </button>
        }
      </div>
    </div>
  </mat-menu>
</div>
